// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"yo-z","slideIn":"zo-z"};